import type { Bildzustand } from '../lib/bild'

/**
 * Ein nicht geladenes Bild — mit der Angabe, an wen der Befund gehört.
 *
 * 404 und 403 sehen für den Menschen davor gleich aus (kein Bild), sind aber
 * zwei verschiedene Probleme: Der eine Fall ist ein Datenstand, der andere
 * eine Leseregel. Wer beides gleich meldet, schickt die Hälfte an die falsche
 * Stelle.
 */
export default function Bildfehler({
  zustand,
  zusatz,
}: {
  zustand: Extract<Bildzustand, { art: 'fehler' }>
  zusatz?: string
}) {
  const marke =
    zustand.ursache === 'datenstand'
      ? 'Datenstand'
      : zustand.ursache === 'regel'
        ? 'Regelproblem'
        : zustand.ursache === 'zugang'
          ? 'Zugang'
          : 'Unerwartet'

  // Datenstand ist eine Beobachtung, alles andere ein Fehler.
  const klasse =
    zustand.ursache === 'datenstand'
      ? 'meldung meldung-warnung'
      : 'meldung meldung-fehler'

  return (
    <p className={klasse} role={zustand.ursache === 'datenstand' ? 'status' : 'alert'}>
      <strong>{marke}: </strong>
      {zustand.meldung}
      {zusatz && ` ${zusatz}`}
    </p>
  )
}
